module.exports = __webpack_public_path__ + "static/media/your-flower-popup-pc.e2ffdf79.jpg";